// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1d3LA","filesListContainer":"PosDisputesFiles_filesListContainer__33WTB","filesButton":"PosDisputesFiles_filesButton__MR6xx"};